<div class="section-1 text-center flex flex-column justify-content-center">
    <h1 class="mt-0 mb-3 font-semibold text-5xl">SARA Plus</h1>
    <div class="mt-0 mb-5 font-semibold	text-xl text-sara-blue">One Application. One Platform. 
        All Devices.</div>
    <div class="mt-0  font-semibold">Powerful management platform that provides end-to-end order tracking, management, and fulfillment to streamline your business operations.</div>
    <!-- <p-button [styleClass]="'justify-content-center bg-sara-blue border-round-md text-lg px-4 py-3 w-full sm:w-auto'" class="mb-4" (click)="onSignUpClicked()">SIGN UP</p-button>
    <p-button [styleClass]="'justify-content-center button-secondary border-round-md px-4 py-3 w-full sm:w-auto'" (click)="onRequestDemoClicked()" [disabled]="true" >REQUEST A DEMO<sup class="mb-2">&nbsp;coming soon</sup></p-button> -->
</div>
<div class="section-2 text-center flex flex-column justify-content-center">
    <h2 class="mt-0 mb-0 font-semibold text-xl">Multi-Provider Order Entry</h2>
    <div class="flex justify-content-center my-5 py-2">
        <div class="">
            <img alt="Sara Plus" class="relative w-9 sm:w-7 md:w-6 lg:w-5 " src="assets/images/portal-screens/order-1.png">
        </div>    
        <div class="">
            <img alt="Sara Plus" class="relative w-9 sm:w-7 md:w-6 lg:w-5" src="assets/images/portal-screens/order-2.png">
        </div>    
    </div>
    <div class="mb-3 pl-3 line-height-3">
        A powerful yet easy-to-use tool that seamlessly consolidates orders from multiple service providers into an efficient, unified system. Featuring automated validation, real-time tracking, and customizable workflows, SARA Plus™ streamlines operations and enhances productivity across the board.
    </div>
</div>
<div class="section-3 text-center flex flex-column justify-content-center">
    <h2 class="mt-0 mb-4 font-semibold text-xl">Reporting</h2>
    <div class="flex line-height-3">
        SARA Plus™ delivers comprehensive insights and analytics on order data, giving users a thorough view of trends, performance metrics, and key indicators. The Reporting feature equips companies with the business intelligence needed to make data-driven decisions and optimize processes, increasing efficiency and effectiveness in order management.
    </div>
</div>
<div class="section-2 text-center flex flex-column justify-content-center">
    <h2 class="mt-0 mb-0 font-semibold text-xl">Secure Data</h2>
    <div class="flex justify-content-between my-5 py-2">
        <div class="flex align-items-center justify-content-center">
            <img alt="Secure Data" class="relative border-round-2xl w-9 sm:w-7 md:w-6 lg:w-5 " src="assets/images/securedata-screens/securedata-1.png">
        </div>    
        <div class="flex align-items-center justify-content-center">
            <img alt="Secure Data" class="relative w-9 border-round-2xl sm:w-7 md:w-6 lg:w-5 " src="assets/images/securedata-screens/securedata-2.png">
        </div> 
        <div class="flex align-items-center justify-content-center">
            <img alt="Secure Data" class="relative w-9 border-round-2xl sm:w-7 md:w-6 lg:w-5 " src="assets/images/securedata-screens/securedata-3.png">
        </div>    
    </div>
    <div class="mb-3 pl-3 line-height-3">
        To protect data integrity and confidentiality, the SARA Plus™ Secure Data infrastructure actively mitigates risks. This provides peace of mind for businesses by safeguarding valuable information from unauthorized access or breaches.
    </div>
</div>
<div id="vendors" class="saraplus-vendor-bg section-5 text-center flex flex-column justify-content-center">
    <h2 class="mt-0 mb-5 pb-2 font-semibold text-xl">Trusted Vendors</h2>
    <div class="vendorStage mb-5 pb-5">
            <img
            src="assets/images/vendors/SARA-Plus.png"
            class="vl saraVendor animate pop"
            alt="SARA Plus™ short logo"
          />
            <div class="vl2 shape animate pop"></div>
            <img
            src="https://www.saraplus.com/css/img/partner-logos/att.png"
            class="vl3 delay-1 attVendor animate pop"
            alt="AT&amp;T logo"
          />
            <img src="assets/images/vendors/directv.png" class="vl4 delay-2 directvVendor animate pop" alt="DIRECTV logo">
            <img src="assets/images/vendors/consolidated.png" class="vl5 delay-3 consolidatedVendor animate pop" alt="Consolidated Communications logo">
            <img src="assets/images/vendors/lumen.png" class="vl6 delay-4 lumenVendor animate pop" alt="Lumen logo">
            <img src="assets/images/vendors/hughesnet.png" class="vl7 delay-5 hughesnetVendor animate pop" alt="Hughesnet logo">
            <img src="assets/images/vendors/earthlink.png" class="vl8 delay-6 earthlinkVendor animate pop" alt="EarthLink logo">
            <img src="assets/images/vendors/viasat.png" class="vl9 delay-7 viasatVendor animate pop" alt="Viasat logo">
            <img src="assets/images/vendors/wow.png" class="vl10 delay-8 wowVendor animate pop" alt="WOW logo">
            <img src="assets/images/vendors/ziply.png" class="vl11 delay-9 ziplyVendor animate pop" alt="Ziply Fiber logo">
            <img src="assets/images/vendors/frontier.png" class="vl12 delay-10 frontierVendor animate pop" alt="Frontier Authorized Sales Agent logo">
            <img src="assets/images/vendors/brightspeed.png" class="vl13 delay-11 brightspeedVendor animate pop" alt="Brightspeed logo">
    </div>
    <div class="flex pt-5 line-height-3 text-center justify-content-center">
            SARA Plus™ is the order entry tool of choice for an ever-growing list of trusted service providers, directly integrating with their systems to simplify and enhance the sales process.
    </div>
</div>